import encode from "./encode";
import decode from "./decode";

const Params = {decode, encode};
export default Params;
export {decode, encode};
